function getTotalItem(sourceData:any): any {
    if(Array.isArray(sourceData)) {
        return sourceData.pop();
    }
}
export default getTotalItem;